// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 498) return "css/2b20133f5728b0a7d88a.498.css";
	// return url for filenames based on template
	return "css/" + "e7b20b63b774113096a3" + "." + "main" + ".css";
};